import { Icon } from '@chakra-ui/react';

export default function HomeIcon(props) {
  return (
    <Icon
      width='28'
      height='25'
      viewBox='0 0 28 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M6.03125 24.8594C4.35547 24.8594 3.38281 23.9102 3.38281 22.2695V11.0898L1.85938 12.3789C1.61328 12.5781 1.34375 12.7539 1.01562 12.7539C0.382812 12.7539 0.0078125 12.2969 0.0078125 11.8164C0.0078125 11.5469 0.125 11.2656 0.382812 11.0547L12.5938 0.800781C13.4727 0.0625 14.5508 0.0625 15.418 0.800781L21.582 5.98047V3.60156C21.582 3.08594 21.9219 2.75781 22.4258 2.75781H23.6797C24.1953 2.75781 24.5234 3.08594 24.5234 3.60156V8.45312L27.6172 11.0547C27.8633 11.2656 27.9805 11.5 27.9805 11.8516C27.9805 12.4141 27.5352 12.7539 26.9844 12.7539C26.6562 12.7539 26.3867 12.5781 26.1523 12.3789L24.5234 11.0078V22.2695C24.5234 23.9102 23.5508 24.8594 21.8867 24.8594H6.03125ZM17.375 15.1211V22.9727H21.4883C22.2266 22.9727 22.6367 22.5508 22.6367 21.7891V9.42578L14.4219 2.53516C14.1641 2.30078 13.8477 2.30078 13.5898 2.53516L5.26953 9.50781V21.7891C5.26953 22.5508 5.67969 22.9727 6.42969 22.9727H10.6133V15.1211C10.6133 14.582 10.9648 14.2305 11.5156 14.2305H16.4844C17.0234 14.2305 17.375 14.582 17.375 15.1211Z' />
    </Icon>
  );
}
